import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'
import LookingForButton from '../LookingForButton'

const PreviousSearches = ({ previousSearches, handleSearch }) => (
  <div className='search-engine-previous-searches'>
    <p className='search-engine-previous-searches__title'>{lang('dashboard_ previous-searches')}</p>
    <div className='search-engine-previous-searches__content'>
      {previousSearches.map((term, index) => index <= 4 && (
        <div className='search-engine-previous-searches__search-item' key={index}>
          <figure className='search-engine-previous-searches__icon'>
            <img src={getStaticImage('/icons/orange-brand/icon-search-dark.svg')} alt='Search' />
          </figure>
          <button
            onClick={() => handleSearch({ value: term.value, type: term.type })}
            className='search-engine-previous-searches__term-btn'
          >
            {term.type !== 'all' ? (
              <LookingForButton onlyTag type={term.type} />
            ) : null}
            <span className='search-engine-previous-searches__term'>
              {term.value}
            </span>
          </button>
        </div>
      ))}
    </div>
  </div>
)

export default PreviousSearches
